// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);
// import 'regenerator-runtime/runtime';

import Sidechain from '@nprapps/sidechain';
const guest = Sidechain.registerGuest({ sentinel: 'st' });

guest.sendMessage({
  type: 'analytics',
  eventCategory: 'interaction',
  eventAction: 'click',
  eventLabel: 'etc'
})

if (document.getElementById("database")) {

const $ = require("jquery");
const d3 = require("d3");
//require("component-responsive-frame/child");
require("./lib/leaflet_map");
const restyleLayer = require("./lib/restyleLayer");
const handleKeyCode = require("./lib/handleKeyCode");



const years = {
  "1971-1972": 1,
  "1980-1981": 2,
  "1990-1991": 3,
  "2000-2001": 4,
  "2010-2011": 5,
  "2021-2022": 6,
  "2022-2023": 7,
}

// orange const colors = ['#aa260d', '#c2412b', '#e75d38', '#ec813d', '#f3bc72', '#fcefcf', '#ccc'];
// purple const colors = ["#632f64", "#89538a", "#b279b2", "#dca1dc", "#ffcaff", "#ffeaff", "#ccc"];
// const colors = ["#b4c7e2", "#8a89a6", "#7b6888", "#6b486b", "#a05d56", "#d0743c", "#ff8c00"];
  //const colors = ['#630d00', '#872f0c', '#ac5219', '#d07425', '#e0a25f', '#efd19a', '#ffffd4'];

const colors = ["#632f64", "#89538a", "#b279b2", "#dca1dc", "#ffcaff", "#ffeaff", "#ccc"];
const keys = ["Black","Asian","Native","Hispanic","NHOPI","TwoOrMoreRaces","White"];

var commafy = s => (s * 1).toLocaleString().replace(/\.0+$/, "");

const data = window.data;
const data_region = window.Region;
const data_district = window.District;
const zeros = window.Zeros;


document.querySelectorAll('#decade_school_data table tr td .color').forEach((el, i) => {
  el.style.backgroundColor = colors[i];
});

var first_school = "AKIKUROSEMIDDLESCHOOL";
var schoolArray = data.filter(function (d) {
 return d.ID === "AKI KUROSE MIDDLE SCHOOL";
});

function getRegionPerMin(year, regionID) {
  let dis_value = data_region.filter(function (d) {
    var yearToString = d.Year;
    yearToString = yearToString.toString();
    return ((d.Geo_ID === regionID) && ( yearToString === year));
  });
  return dis_value[0].Per_Minority;
};

function getDistrictPerMin(year) {
  let dis_value = data_district.filter(function (d) {
    var yearToString = d.Year;
    yearToString = yearToString.toString();
    return yearToString === year;
  });
  return dis_value[0].Per_Minority;
};




// document.querySelector("#myInput").addEventListener("keyup", () => txtSearch());
document.getElementById("myInput").addEventListener("keyup", () => handleKeyCode(event));

// document.onkeyup = handleKeyCode(e);

document.querySelector("#myInput").addEventListener("focus", () => {
  document.querySelector(".dropdownList").classList.remove('hide');
  document.querySelector(".dropdownList").setAttribute('aria-expanded', true);
});

document.querySelector(".close").addEventListener("click", () => {
  document.querySelector(".dropdownList").classList.add('hide');
  document.querySelector(".dropdownList").setAttribute('aria-expanded', false);
  document.querySelector("#myInput").value = '';
});

document.querySelector("#card").addEventListener("click", () => {
  document.querySelector(".dropdownList").classList.add('hide');
  document.querySelector(".dropdownList").setAttribute('aria-expanded', false);
  document.querySelector("#myInput").value = '';
});


document.querySelectorAll(".dropdownList .item").forEach(el => el.addEventListener('click', () => {
  document.querySelector(".dropdownList").classList.add('hide');
  document.querySelector(".dropdownList").setAttribute('aria-expanded', false);
  document.querySelector("#myInput").value = '';
  handleKeyCode(event);


  var school_id = el.innerText;
  var schoolRegion = el.dataset.region;
  schoolArray = data.filter(function (d) {
   return d.ID === school_id;
 });



 var school_name_class = school_id.replace(/\s/g, '');
 school_name_class = school_name_class.replace(/[^a-zA-Z0-9]/g, '');

 document.querySelectorAll(".leaflet-marker-icon.school").forEach(el => el.classList.remove('show'));
 document.querySelector(`.leaflet-marker-icon.school.${school_name_class}`).classList.add('show');

 fillCard(schoolArray);
 fillTable(schoolArray);
 updateBarChart(schoolArray);
 showToolipData("2022-2023");
 restyleLayer(schoolRegion);
}));




// graph stuff


fillCard(schoolArray);
fillTable(schoolArray);
restyleLayer('SE');
document.querySelector(`.leaflet-marker-icon.school.${first_school}`).classList.add('show');

function fillCard(pickedSchoolArray) {
  document.querySelector("#card .previously").classList.remove('active');
  document.querySelector("#card .missing").classList.remove('active');
  let alias = [];
  let alias_text = '';
  let missingData = [];
  let missingData_text = '';
  let mostRecentYear = pickedSchoolArray[pickedSchoolArray.length - 1];
  let firstYear = pickedSchoolArray[0].Year;
  firstYear = firstYear.split("-");
  document.querySelector("#card .name").innerText = mostRecentYear.ID;
  document.querySelector("#card .address").innerText = mostRecentYear.Address_cap;
  document.querySelector("#card .region").innerText = mostRecentYear.RegionNm;
  document.querySelector("#card #startDate").innerText = firstYear[0];

  pickedSchoolArray.map(item => {
    if (item.Formerly_cap) {
      alias.push(item.Formerly_cap);
      document.querySelector("#card .previously").classList.add('active');
    }
    if (item.Data_missing) {
      document.querySelector("#card .missing").classList.add('active');
      var year = item.Year;
      year = year.split("-");
      missingData.push(year[0]);
    }
  });

  alias.map((item, index) => {
    alias_text = (index === 0) ? item : (alias_text + `, ${item}`);
  });
  document.querySelector("#card .previously span").innerHTML = alias_text;
  missingData.map((item, index) => {
    missingData_text = (index === 0) ? item : (missingData_text + `, ${item}`);
  });
  (missingData.length > 1) ? document.querySelector("#card .missing .multiple").classList.add('active') : document.querySelector("#card .missing .multiple").classList.remove('active');
  document.querySelector("#card .missing .fill").innerHTML = missingData_text;
};

function fillTable(pickedSchoolArray) {
  document.querySelectorAll("#comparison-areas-table .row").forEach(el => el.style.display = "none");
  document.querySelectorAll("#comparison-areas-table .row").forEach(el => el.style.backgroundColor = "transparent");
  var evenOrOdd = 0;
  pickedSchoolArray.forEach(element => {
    if (element.Data_missing) {
      return;
    } else {
      let year = element.Year;
      year = year.split("-");
      year = year[0];
      document.querySelector(`#comparison-areas-table tr[data-row="${year}"]`).style.display = "revert";
      // console.log(evenOrOdd);
      document.querySelector(`#comparison-areas-table tr[data-row="${year}"]`).style.backgroundColor = (evenOrOdd % 2 == 0) ? "#ddd" : "none";
      evenOrOdd += 1;

      var school = (element.PerMinority) ? (element.PerMinority).toFixed(1) : "N/A";
      document.querySelector(`#card table tr[data-row="${year}"] td[data-cell="school"] span`).innerText = school;
      var region = getRegionPerMin(year, element.GeoRgn);
      document.querySelector(`#card table tr[data-row="${year}"] td[data-cell="region"] span`).innerText = region.toFixed(1);
      var district = getDistrictPerMin(year);
      document.querySelector(`#card table tr[data-row="${year}"] td[data-cell="district"] span`).innerText = district.toFixed(1);
    }
  });
};

var graph_width = document.querySelector("#graph").offsetWidth;
var graph_height = graph_width > 450 ? 300 : 270;

// set the dimensions and margins of the graph
var margin = {top: 20, right: 20, bottom: 30, left: 40},
    width = graph_width - margin.left - margin.right,
    height = graph_height - margin.top - margin.bottom;

var svg = d3.select('#graph').append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
  .append("g")
    .attr("transform",
          "translate(" + margin.left + "," + margin.top + ")");


  // set the ranges
    // var x = d3.scaleBand()
    //           .range([0, width])
    //           .padding(0.1);
  var y = d3.scaleLinear()
            .range([height, 0]);

  var x0 = d3.scaleBand().range([0, width]).padding(0.3);
  var x1 = d3.scaleBand();

  var color = d3.scaleOrdinal().range(colors);

  var innerColumns = {
  "column1" : ["Black","Asian","Native","Hispanic","NHOPI","TwoOrMoreRaces","White"],
  }

var columnHeaders = keys;
color.domain(keys);

schoolArray.forEach(function(d) {
  var yColumn = new Array();
  d.columnDetails = columnHeaders.map(function(name) {
      if($.inArray(name, keys) >= 0){
        if (!yColumn[keys]){
          yColumn[keys] = 0;
        }
        yBegin = yColumn[keys];
        // console.log(yBegin);
        var yEndNumber = (+d[name] === 0) ? 0 : ((+d[name] / d.School) * 100);
        yColumn[keys] += (+d[name] / d.School) * 100;
        return {name: name, column: "one", yBegin: yBegin, yEnd: yEndNumber + yBegin,};
      }
  });
  d.total = d3.max(d.columnDetails, function(d) {
    return d.yEnd;
  });
});


x0.domain(data.map(function(d) { return d.Year; }));
x1.domain(d3.keys(innerColumns)).range([0, x0.bandwidth()]);
y.domain([0, 100]);
// y.domain([0, d3.max(data, function(d) {
//   return d.total;
// })]);

var strokes = svg.append("g").attr("class", "strokes");

  strokes.selectAll("rect")
      .data(schoolArray)
      .enter().append("rect")
      .attr("transform", function(d) { return "translate(" + (x0(d.Year) - 2) + ",0)"; })
      .attr("class", function(d) { return `s${d.Year}`; })
      .attr("width", (x1.bandwidth() + 4))
      .attr("x", function(d) {
        return x1(d.Year);
         })
      .attr("y", function(d) {
        return (y(100));
      })
      .attr("height", function(d) {
        return height - y(100);
      });


var project_stackedbar = svg.append("g").attr("class", "allBars").selectAll(".project_stackedbar")
      .data(schoolArray)
    .enter().append("g")
      .attr("class", function(d) { return `bar g${d.Year}`; })
      .attr("transform", function(d) { return "translate(" + x0(d.Year) + ",0)"; })
      .on('click', function(d,i){ showToolipData(d.Year); });



  project_stackedbar.selectAll("rect")
      .data(function(d) { return d.columnDetails; })
    .enter().append("rect")
      .attr("width", x1.bandwidth())
      .attr("x", function(d) {
        return x1(d.column);
         })
      .attr("y", function(d) {
        return y(d.yEnd);
      })
      .attr("height", function(d) {
        return y(d.yBegin) - y(d.yEnd);
      })
      .style("fill", function(d) {
          return color(d.name);
      });


  // add the x Axis
  svg.append("g")
      .attr("class", "xAxis")
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x0).tickSizeOuter(0).tickFormat(d => {
        if (graph_width > 500) {
          return d;
        } else {
          d = d.split("-");
          return d[0];
        }
      }));

  // add the y Axis
  svg.append("g")
      .attr("class", "yAxis")
      .call(d3.axisLeft(y).tickFormat((d, i) => {
        return i % 2 == 0 ? d + "%" : '' }));

showToolipData("2022-2023");

function updateBarChart(chosenSchoolArray) {
  console.log(chosenSchoolArray);

const tryMe = zeros.map(x => {
  var filteredArray = chosenSchoolArray.filter(e => e.Year === x.Year);
  return (filteredArray.length > 0) ? filteredArray[0] : x;
});

// console.log(tryMe);


strokes.selectAll("rect")
    .data(tryMe)
    .transition()
    .duration(500)
    .attr("y", function(d) {
      // console.log(d);
      return y(100);
    })
    .attr("height", function(d) {
      return height - y(100);
    })

  tryMe.forEach(function(d) {
    var yColumn = new Array();
    d.columnDetails = columnHeaders.map(function(name) {
        if($.inArray(name, keys) >= 0){
          if (!yColumn[keys]){
            yColumn[keys] = 0;
          }
          yBegin = yColumn[keys];
          // console.log(yBegin);
          var yEndNumber = (+d[name] === 0) ? 0 : ((+d[name] / d.School) * 100);
          yColumn[keys] += (+d[name] / d.School) * 100;
          return {name: name, column: "one", yBegin: yBegin, yEnd: yEndNumber + yBegin,};
        }
    });
    d.total = d3.max(d.columnDetails, function(d) {
      return d.yEnd;
    });
  });

  project_stackedbar.data(tryMe);

  project_stackedbar.selectAll("rect")
      .data(function(d) { return d.columnDetails; })
      .transition()
      .duration(500)
      .attr("y", function(d) {
        return y(d.yEnd);
      })
      .attr("height", function(d) {
        return y(d.yBegin) - y(d.yEnd);
      });

};

// document.querySelector("#tryme").addEventListener("click", () => updateBar());


function showToolipData(yearData) {
  document.querySelectorAll('svg .strokes rect').forEach(el => el.classList.remove('highlight'));
  document.querySelectorAll('svg .xAxis .tick').forEach(el => el.classList.remove('highlight'));
  var tooltip_data = schoolArray.filter(function (d) {
   return d.Year === yearData;
  });
  tooltip_data = tooltip_data[0];

  document.querySelector(`svg .xAxis .tick:nth-of-type(${years[yearData]})`).classList.add('highlight');

  document.querySelector(`svg .strokes .s${yearData}`).classList.add('highlight');

  document.querySelectorAll('#decade_school_data [data-plug]').forEach((el, i) => {
    let get_object_key = el.dataset.plug;
    let ready_text = "";

    if (get_object_key === "PerMinority") {
      ready_text = (tooltip_data[get_object_key]).toFixed(1);
    } else if ((get_object_key === "Year") || (get_object_key === "ID")) {
      ready_text = (tooltip_data[get_object_key]);
    } else if ((get_object_key === "NHOPI") || (get_object_key === "TwoOrMoreRaces")) {
      ready_text = (tooltip_data["Year"] < "2010-2011") ? "N/A" : commafy(tooltip_data[get_object_key]);
    } else {
      ready_text = commafy(tooltip_data[get_object_key]);
    }

    if (get_object_key === "PerMinority") {
      el.querySelector('span').innerHTML =  ready_text;
    } else { el.innerHTML =  ready_text; }
    // el.innerHTML =  ready_text;
  });

  document.querySelectorAll('#decade_school_data [data-percent]').forEach((el, i) => {
    let get_object_key = el.dataset.percent;
    let ready_text = ((tooltip_data[get_object_key] / tooltip_data["School"]) * 100).toFixed(1);
    el.querySelector('span').innerHTML =  ready_text;
  });
}


} // end of javascript for database
